import cartQuickBuyHtml from './cartquickbuy.component.html';

class CartQuickBuyController {
    constructor($scope, $http, CartService, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.SnackbarService = SnackbarService;
        this.service = CartService;
    }

    $onInit() {
    }

    get sliderSize() {
        const len = this.products.length;

        if (len > 6) {
            return '6.5';
        }

        if (len === 6) {
            return '6';
        }

        if (len > 4) {
            return '4.5';
        }

        return '4';
    }

    get sliderOverflow() {
        const len = this.products.length;

        if (len === 6 || len < 4) {
            return false;
        }

        return true;
    }

    hasProductIdFilter() {
        return this.productId !== undefined && this.productId !== null && `${this.productId}` !== '';
    }

    getFilteredSimilarProducts() {
        let list = this.service.similarProducts || [];

        if (this.hasProductIdFilter()) {
            const pid = parseInt(this.productId, 10);

            list = list.filter(p => {
                const ids = p && p.similar_for_product_ids;

                if (!Array.isArray(ids)) {
                    return false;
                }

                return ids.map(x => parseInt(x, 10)).includes(pid);
            });
        }

        return list;
    }

    get products() {
        let list = this.getFilteredSimilarProducts();

        if (!this.limitItems || this.limitItems <= 0) {
            return list;
        }

        return list.slice(0, this.limitItems);
    }

    buy(product) {
        product.loading = true;

        this.$http.post(
            '/ajax/checkout/add-to-cart',
            {
                productId: parseInt(product.id, 10),
                variantId: product.variant_id ? parseInt(product.variant_id, 10) : 0,
                quantity: 1,
                voucher: null
            }
        ).then(
            response => {
                if (response.data.message && response.data.message.type != 'success') {
                    const message = response.data.message.content;
                    this.SnackbarService.add(message, 'error', true, 3000);
                    product.loading = false;
                    return;
                }

                this.SnackbarService.add(response.data.message.content, 'success', true, 3000);
                this.service.load();
                product.loading = false;
            },
            () => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
                product.loading = false;
            }
        );
    }
}

let cartQuickBuyComponent = {
    bindings: {
        limitItems: '<?',
        productId: '<?'
    },
    template: cartQuickBuyHtml,
    controller: CartQuickBuyController
}

export default cartQuickBuyComponent;